// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import { media } from '@leasen_nl/listo/src/helpers';
import StyledRow from '@leasen_nl/listo/src/components/row/row.styled';
import { Container, Flex } from '@leasen_nl/listo/src/components/grid';
import type { Theme } from '@types/index';

type RowProps = {|
  children: Node | Array<Node>,
  className: string,
|};

// @todo this component should be properly implemented in Listo
// see https://justlease.atlassian.net/browse/LISTO-294
const Row = ({ className, children }: RowProps) => (
  <StyledRow className={className}>
    <Container>
      <Flex width={1} wrap>{children}</Flex>
    </Container>
  </StyledRow>
);

export default styled<any, Theme>(Row)`
  &:last-child {
    margin-bottom: 2rem;
  }

  ${media.lg(css`
    margin-bottom: 4rem;

    &:last-child {
      margin-bottom: 4rem;
    }
  `)}
`;
